import { css } from '@emotion/core'
import { NOT_PHONES, PHONES } from 'styles/media-queries'
import { measures } from 'styles/variables'

const { unit } = measures

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const row = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  ${PHONES} {
    justify-content: space-between;
  }
  ${NOT_PHONES} {
    & label {
      min-width: ${24 * unit}px;
    }
  }
`
